import { useEffect } from 'react';

export function useFocusOut({
  ref,
  onFocusOut,
  handleClick = true,
  handleKeyup = false,
}: {
  ref: HTMLElement | null;
  onFocusOut: (isFocusOut: boolean) => void;
  handleClick?: boolean;
  handleKeyup?: boolean;
}) {
  useEffect(() => {
    const handleFocusOutEvent = (ref: HTMLElement, event: MouseEvent | KeyboardEvent) => {
      if (ref.contains(event.target as Node)) {
        onFocusOut(false);
      } else {
        onFocusOut(true);
      }
    };

    const clickListener = (event: MouseEvent) => {
      if (ref && handleClick) {
        handleFocusOutEvent(ref, event);
      }
    };

    const keyupListener = (event: KeyboardEvent) => {
      if (ref && handleKeyup && event.key === 'Tab') {
        handleFocusOutEvent(ref, event);
      }
    };

    document.addEventListener('click', clickListener);
    document.addEventListener('keyup', keyupListener);

    return () => {
      document.removeEventListener('click', clickListener);
      document.removeEventListener('keyup', keyupListener);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref]);
}
